// extracted by mini-css-extract-plugin
export default {"progressWrapper":"ProgressEpoch_progressWrapper__vp2g7","progress":"ProgressEpoch_progress__4i8Iy"};